import Result from './result'
import Ok from './ok'
import Error from './error'
export {Result,Ok,Error}